export * from './message-one-item.interface';
